import React from 'react';
import MoreBtn from './MoreBtn';
import style from '../css/More.module.css';
import { FaScrewdriverWrench } from 'react-icons/fa6';
import {
	FaChalkboard,
	FaHome,
	FaList,
	FaPhoneAlt,
	FaRegWindowClose,
	FaTeamspeak,
	FaThumbsUp,
	FaTruckMoving,
	FaUser,
} from 'react-icons/fa';
import HeaderBar from './HeaderBar';

function More() {
	return (
		<div>
			<HeaderBar
				text={'More Options'}
				icon={<FaRegWindowClose color="black" size={20} />}
				navi="/dashboard"
			/>

			<div className={style.btns}>
				<MoreBtn
					toLink={'tel:+917411741171'}
					icon={<FaPhoneAlt color="black" size={20} />}
					text={'Call Us'}
				/>

				<MoreBtn
					toLink={'https://hometech-repairs.in/'}
					icon={<FaChalkboard color="black" size={20} />}
					text={'Website'}
				/>

				<MoreBtn
					toLink={'/dashboard'}
					icon={<FaHome color="black" size={20} />}
					text={'Dashboard'}
				/>

				<MoreBtn
					toLink={'/upcoming-service'}
					icon={<FaScrewdriverWrench color="black" size={20} />}
					text={'Upcoming Service'}
				/>

				<MoreBtn
					toLink={'/book-repair'}
					icon={<FaTruckMoving color="black" size={20} />}
					text={'New Booking'}
				/>

				<MoreBtn
					toLink={'/service-history'}
					icon={<FaList color="black" size={20} />}
					text={'Service History'}
				/>

				<MoreBtn
					toLink={'/profile'}
					icon={<FaUser color="black" size={20} />}
					text={'Profile'}
				/>

				<MoreBtn
					toLink={'/your-address'}
					icon={<FaHome color="black" size={20} />}
					text={'My Address'}
				/>

				<MoreBtn
					toLink={'/feed-back'}
					icon={<FaThumbsUp color="black" size={20} />}
					text={'Feedback'}
				/>

				<MoreBtn
					toLink={'/support'}
					icon={<FaTeamspeak color="black" size={20} />}
					text={'Support'}
				/>
			</div>
		</div>
	);
}

export default More;
